import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router";
import debounce from "lodash.debounce";

import { Icon, Input, AutoComplete } from "antd";
import { connect } from "react-redux";
import { fetchTextures } from "../actions";
import totalCount from "./totalCount";

class SearchTextures extends Component {
  state = { results: [] };

  handleSearchChange = debounce(async value => {
    let results = (await axios.get("/api/fetch_tags", {
      params: { filter: value },
    })).data;
    results = results.map(result => {
      return { text: `${result.tag}(${result.count}) `, value: result.tag };
    });
    this.setState({ results });
  }, 200);
  // renderOptions = () => {
  //
  //   this.state.results.map(result => (
  //     result.title
  //   ))
  // }

  handleSelect = async result => {
    this.props.fetchTextures({ tag: result });
    this.props.history.push({ pathname: "/search", search: result });
  };

  render() {
    return (
      <div className="global-search-wrapper" style={{ width: 200 }}>
        <AutoComplete
          className="global-search"
          style={{ width: "100%", height: "2em" }}
          dataSource={this.state.results}
          onSelect={this.handleSelect}
          onSearch={this.handleSearchChange}
          placeholder={<span style={{ color: "grey" }}>Search {totalCount} textures...</span>}
          optionLabelProp="text"
        >
          <Input suffix={<Icon type="search" className="hvr-grow" />} />
        </AutoComplete>
      </div>
    );
  }
}

export default withRouter(
  connect(
    null,
    {
      fetchTextures,
    }
  )(SearchTextures)
);



// WEBPACK FOOTER //
// ./src/components/SearchTextures.js